import React, { Component } from 'react';

class Close extends Component {
	render() {
		return (
			<div className="close-link"><a href="https://lartorget.sll.se/Extern/activitycentre/activitycentre.aspx"><i class="far fa-times-circle"></i><span>Stäng</span></a></div>
		);
	}
}

export default Close;


// WEBPACK FOOTER //
// ./src/components/Close.js